import script from "./CreateNewProductPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNewProductPopup.vue?vue&type=script&setup=true&lang=js"

import "./CreateNewProductPopup.vue?vue&type=style&index=0&id=4897b810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4897b810"]])

export default __exports__